import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '@/lib/api';
import toast from 'react-hot-toast';

const C = { or: '#B8960A', noir: '#1A1710', border: '#E8D8A8' };
const IS = { width: '100%', padding: '10px 14px', border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' as const, fontFamily: 'inherit' };

const schema = z.object({
  password: z.string().min(8, 'Minimum 8 caractères'),
  confirm: z.string(),
}).refine(d => d.password === d.confirm, { message: 'Les mots de passe ne correspondent pas', path: ['confirm'] });

type FormData = z.infer<typeof schema>;

export default function ResetPasswordPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<FormData>({ resolver: zodResolver(schema) });

  const onSubmit = async (data: FormData) => {
    try {
      await api.post('/auth/reset-password', { token, password: data.password });
      toast.success('Mot de passe réinitialisé');
      navigate('/login');
    } catch (err: unknown) {
      toast.error((err as { response?: { data?: { message?: string } } })?.response?.data?.message ?? 'Lien invalide ou expiré');
    }
  };

  return (
    <div style={{ minHeight: '100dvh', background: 'linear-gradient(135deg, #F9F1E7 0%, #F2E4CC 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 20, boxShadow: '0 8px 40px rgba(26,23,16,0.12)', width: '100%', maxWidth: 420, padding: '40px 36px' }}>
        <div style={{ height: 48, backgroundImage: 'url(/logo_vaeg_assist.png)', backgroundSize: 'contain', backgroundPosition: 'center left', backgroundRepeat: 'no-repeat', marginBottom: 28 }} />
        <h1 style={{ fontSize: 20, fontWeight: 700, color: C.noir, marginBottom: 6 }}>Nouveau mot de passe</h1>
        <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 24 }}>Choisissez un mot de passe sécurisé pour votre compte.</p>

        <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Nouveau mot de passe</label>
            <input {...register('password')} type="password" style={IS} />
            {errors.password && <p style={{ fontSize: 12, color: '#dc2626', marginTop: 4 }}>{errors.password.message}</p>}
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Confirmer le mot de passe</label>
            <input {...register('confirm')} type="password" style={IS} />
            {errors.confirm && <p style={{ fontSize: 12, color: '#dc2626', marginTop: 4 }}>{errors.confirm.message}</p>}
          </div>
          <button type="submit" disabled={isSubmitting} style={{ height: 42, background: C.or, color: '#fff', border: 'none', borderRadius: 9, fontSize: 14, fontWeight: 600, cursor: isSubmitting ? 'not-allowed' : 'pointer', opacity: isSubmitting ? 0.7 : 1 }}>
            {isSubmitting ? 'Enregistrement...' : 'Réinitialiser mon mot de passe'}
          </button>
        </form>
      </div>
    </div>
  );
}
